import { HeadProvider, Title } from 'react-head';
import ClientsDataTable from '../components/clients/ClientsDataTable';




const Clients = () => {
    return (
        <>
            <HeadProvider>
                <Title>Errores Security System</Title> {/* Establecemos el título de la página utilizando el componente Title */}
            </HeadProvider>
            <ClientsDataTable/>

        </>
    );
};

export default Clients;
